<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['library_books'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="mb-2 float-end">
                <div>
                  <b-button
                    v-b-modal.new-librarybook
                    size="sm"
                    variant="primary"
                    ><i class="mdi mdi-plus"></i> New Library Book</b-button
                  >
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="
                          edit(
                            data.item.id,
                            data.item.booktitle,
                            data.item.author,
                            data.item.category,
                            data.item.quantity,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="
                          remove(
                            data.item.id,
                            data.item.booktitle,
                            data.item.author,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-librarybook"
        centered
        title="New Library Book"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addBook">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Book title</label>
            <b-form-input
              v-model="booktitle"
              label="Book title"
              type="text"
            ></b-form-input>
            <label>Author</label>
            <b-form-input
              v-model="author"
              label="Author"
              type="text"
            ></b-form-input>
            <label>Category</label>
            <multiselect
              v-model="category"
              label="name"
              :options="bookcategories"
            ></multiselect>
            <label>Quantity</label>
            <b-form-input v-model="quantity" type="number"></b-form-input>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-librarybook')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-book"
        centered
        title="Edit Book"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editBook">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Book title</label>
            <b-form-input
              v-model="booktitle"
              label="Book title"
              type="text"
            ></b-form-input>
            <label>Author</label>
            <b-form-input
              v-model="author"
              label="Author"
              type="text"
            ></b-form-input>
            <label>Category</label>
            <b-form-input
              v-model="category"
              label="Category"
              type="text"
            ></b-form-input>
            <label>Quantity</label>
            <b-form-input v-model="quantity" type="number"></b-form-input>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-book')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-book"
        centered
        title="Delete Book"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeBook">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Book
          <b>{{ booktitle.booktitle }}</b> by <b>{{ booktitle.author }}</b
          >?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-book')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  bookCategoriesComputed,
  bookCategoriesMethods,
  libraryBooksComputed,
  libraryBooksMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

//import bookstore from "./bookstore.vue";

export default {
  page: {
    title: "Library Books",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Library books",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Library books", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "booktitle", label: "Book title", visible: true },
        { key: "author", label: "Author", visible: true },
        { key: "category", label: "Category", visible: true },
        { key: "quantity", label: "Quantity", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      booktitle: "",
      category: "",
      author: "",
      quantity: "",
    };
  },
  computed: {
    ...libraryBooksComputed,
    ...bookCategoriesComputed,
    List() {
      return this.librarybooks.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.librarybooks.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.librarybooks.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchLibraryBooks();
    this.fetchBookcategories();
    this.TotalRows = this.librarybooks.length;
    this.isBusy = false;
  },
  methods: {
    ...libraryBooksMethods,
    ...bookCategoriesMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, booktitle, author, category, quantity) {
      this.id = id;
      this.booktitle = booktitle;
      this.author = author;
      this.category = category;
      this.quantity = quantity;
      this.$bvModal.show("edit-book");
    },
    remove(id, booktitle, author) {
      this.id = id;
      this.booktitle = booktitle;
      this.author = author;
      this.$bvModal.show("delete-book");
    },
    async addBook() {
      let formData = new FormData();
      formData.append("booktitle", this.booktitle);
      formData.append("author", this.author);
      formData.append("category", this.category.name);
      formData.append("quantity", this.quantity);
      let url = "/addlibrarybooks";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLibraryBooks();
          this.$bvModal.hide("new-librarybook");
          this.booktitle = "";
          this.author = "";
          this.category = "";
          this.quanntity = "";
          this.$swal({
            title: "Successfully added",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editBook() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("booktitle", this.booktitle);
      formData.append("author", this.author);
      formData.append("category", this.category);
      formData.append("quantity", this.quantity);
      let url = "/updatelibrarybooks";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLibraryBooks();
          this.$bvModal.hide("edit-book");
          this.id = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeBook() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removelibrarybooks";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLibraryBooks();
          this.$bvModal.hide("delete-book");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
